import React, { useState } from 'react';
import '../Homepage/Navbar/Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    document.body.style.overflow = !isMenuOpen ? 'hidden' : ''; // Prevent scrolling when menu is open
  };
  
  const handleDropdownToggle = (index) => {
    setActiveDropdown(activeDropdown === index ? null : index);
  };

  const navItems = [
    { 
      name: "HOME", 
      route: "/",
      dropdown: [] // No dropdown for home
    },
    { 
      name: "OPAC", 
      route: "/coming-soon",
      dropdown: [] // No dropdown for home
    },
    { 
      name: "Commitee", 
      route: "/coming-soon",
      dropdown: [] // No dropdown for home
    },
    { 
      name: "e-Resources", 
      route: "/coming-soon",
      dropdown: [] // No dropdown for home
    },
    { 
      name: "e-journals", 
      route: "/e-journals",
      dropdown: [] // No dropdown for home
    },
    { 
      name: "Drilbit", 
      route: "/coming-soon",
      dropdown: [] // No dropdown for home
    },
    { 
      name: "Guidlines", 
      route: "/guidelines",
      dropdown: [] // No dropdown for home
    },
    { 
      name: "Open-Access", 
      route: "/open-access",
      dropdown: [] // No dropdown for home
    },
    { 
      name: "Staff", 
      route: "/staff",
      dropdown: [] // No dropdown for home
    },
    

    
  ];

  return (
    <nav className="navbar">
      {/* Header/Branding Area */}
      <div className="navbar-header">
        <div className="navbar-container">
          <div className="navbar-branding">
            {/* Left side - English text */}
            <div className="navbar-logo gov-logo">
                <img src="/APgov.png" alt="Government of AP Logo" />
              </div>
              <div className="navbar-logo ugc-logo">
                <img src="/UGC.png" alt="UGC Logo" />
              </div>

            <div className="navbar-title-english">
              <span className="navbar-acronym">A State University</span>
              <h1>Rayalaseema University</h1>
              <p className="navbar-tagline">Kurnool, Andhra Pradesh</p>
            </div>
            
            {/* Center - Logos */}
            <div className="navbar-logos">
              
              
              <div className="navbar-logo university-logo">
                <img src="/logo.png" alt="Rayalaseema University Logo" />
              </div>
              
            </div>
            
            {/* Right side - Telugu text */}
            <div className="navbar-title-telugu">
              <span className="navbar-acronym">రాష్ట్ర విశ్వవిద్యాలయం</span>
              <h1>రాయలసీమ విశ్వవిద్యాలయం</h1>
              <p className="navbar-tagline">కర్నూలు, ఆంధ్రప్రదేశ్</p>
            </div>
            <div className="navbar-logo naac-logo">
                <img src="/NAAC.png" alt="NAAC B Grade Logo" />
              </div>
              <div className="navbar-logo naac-logo">
                <img src="/ncte.png" alt="NCTE Logo" />
              </div>
            {/* Hamburger Menu Button for Mobile */}
            <button 
              className={`navbar-hamburger ${isMenuOpen ? 'active' : ''}`}
              onClick={toggleMenu}
              aria-expanded={isMenuOpen}
              aria-label="Toggle navigation menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>

      {/* Main Navigation Menu */}
      <div className="navbar-navigation">
        <div className="navbar-container">

          {/* Navigation Menu */}
          <div className={`navbar-menu ${isMenuOpen ? 'open' : ''}`}>
            <ul>
              {navItems.map((item, index) => (
                <li 
                  key={index} 
                  className={`nav-item ${item.dropdown.length > 0 ? 'has-dropdown' : ''} ${activeDropdown === index ? 'dropdown-active' : ''}`}
                  onMouseEnter={() => window.innerWidth >= 992 && handleDropdownToggle(index)}
                  onMouseLeave={() => window.innerWidth >= 992 && handleDropdownToggle(null)}
                >
                  <a 
                    href={item.route}
                    onClick={(e) => {
                      if ((item.dropdown?.length > 0 || item.megaMenu) && window.innerWidth < 992) {
                        e.preventDefault();
                        handleDropdownToggle(index);
                      }
                    }}
                  >
                    {item.name}
                    {(item.dropdown?.length > 0 || item.megaMenu) && <span className="dropdown-arrow">▼</span>}
                  </a>
                  
                  {/* Mega Menu for Academics */}
                  {item.megaMenu && item.columns && (
                    <div className={`mega-menu ${activeDropdown === index ? 'show' : ''}`}>
                      <div className="mega-menu-container">
                        {item.columns.map((column, columnIndex) => (
                          <div key={columnIndex} className="mega-menu-column">
                            <h3 className="mega-menu-heading">{column.heading}</h3>
                            <div className="mega-menu-links">
                              {column.links.map((link, linkIndex) => (
                                <a key={linkIndex} href={link.route} className="mega-menu-link">
                                  {link.name}
                                </a>
                              ))}
                            </div>
                            {columnIndex < item.columns.length - 1 && <div className="vertical-divider"></div>}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  
                  {/* Regular Dropdown Menu */}
                  {item.dropdown && item.dropdown.length > 0 && !item.megaMenu && (
                    <div className={`dropdown-menu ${activeDropdown === index ? 'show' : ''}`}>
                      {item.dropdown.map((dropdownItem, dropdownIndex) => (
                        <a key={dropdownIndex} href={dropdownItem.route} className="dropdown-item">
                          {dropdownItem.name}
                        </a>
                      ))}
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;